/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { ALIGN, CanvasContent, ILandingSection } from "src/modules/pe-landing-module/data/interfaces"
import { getCssDemention } from "src/libs/utilities/getCssDemention"
import { default as CanvasCanvas } from "../useful/Canvas"
import Dummy from "./Dummy"
import { setHorizontalAlignToCSSRule, setVerticalAlignToCSSRule } from "../section/Section"
import useComponentData from "src/modules/pe-landing-module/hooks/useComponentData"
import DataContentEditor from "../landing-edit/editors/data-content-editor"


/* Protopia Ecosystem component */
export interface ICanvasProps {
    section: ILandingSection
    data: CanvasContent 
}
const Canvas = ({section, ...props}: ICanvasProps): JSX.Element => {
    const data: CanvasContent   = useComponentData<CanvasContent>(( props.data || {dimentions: {}} ) as CanvasContent )  
    const [width]               = useState<string>(getCssDemention( data.width, "100%" ))
    const [height, ]            = useState<string>(getCssDemention( data.height, "fit-content" ))
    const horizontalAlign       = useState<string>( setHorizontalAlignToCSSRule( data?.horizontal_align ||ALIGN.MIDDLE) )
    const vertical_align        = useState<string>( setVerticalAlignToCSSRule( data?.vertical_align ||ALIGN.MIDDLE) )
    useEffect(() => { 
        addCSSClass(
            `landing-canvas-${data.id}`,
            `.landing-canvas-${data.id} { 
                max-width: ${ getCssDemention( data.width, "100%" ) };
                max-height: ${ getCssDemention( data.height, "fit-content" ) };
                width: ${ getCssDemention( data.width, "100%" ) };
                height: ${ getCssDemention( data.height, "fit-content" ) };
                ${horizontalAlign}
                ${vertical_align}
                z-index:1;
            } 
            `
        )
        return () => {
            removeCSSClass(`landing-canvas-${data.id}`)
        }
    },[ data ])
    
    return !!data.value || true
        ?
        <div className={`pe-canvas-container landing-content-container`} data-type={data.type} data-content-id={data.id}> 
            <div className={`landing-canvas landing-canvas-${ data.id } ${ data.className || "" } `} style={data.containerStyle}>
                <CanvasCanvas data={{ ...data as any }} />
            </div>
            <DataContentEditor data={data}  section={section} />
        </div>
        :
        <Dummy {...{ 
            ...{
                data: {
                    ...data,
                    className: ` ${data.className} landing-canvas-${ data.id } `
                },
            }, 
            ...props 
        }} />
}
export default Canvas